import usePageContext from '@rover/react-lib/src/context/usePageContext';
import { selectors as countryRegionLinksSelectors } from '@rover/react-lib/src/redux/ducks/countryRegionLinks.duck';
import { useApiCountryRegionLinksList } from '@rover/rsdk/src/apiClient/latest/api-country-region-links-list';
import type { PaginatedCountryRegionLinkList } from '@rover/rsdk/src/apiClient/latest/model/paginatedCountryRegionLinkList';
import { getURL } from '@rover/shared/js/utils/getFullUrl';
import { getCountryUrlPrefix, US_COUNTRY_URL_PREFIX } from '@rover/utilities/roverGeo.constants';

import useDucks from './useDucks';

const selector = countryRegionLinksSelectors.getCountryRegionLinks;

const useCountryRegionLinksShim = (): PaginatedCountryRegionLinkList => {
  const { isReactQueryRoute } = usePageContext();
  const location = getURL();
  const countryUrlPrefix = getCountryUrlPrefix(location.pathname) ?? US_COUNTRY_URL_PREFIX;

  const { data: selectedData } = useDucks({ selector });
  const { data: reactQueryData } = useApiCountryRegionLinksList(
    { countryUrlPrefix },
    {
      query: { enabled: isReactQueryRoute },
    }
  );

  const fallback: PaginatedCountryRegionLinkList = {
    count: 0,
    results: [],
    countryFlag: '',
    countryName: '',
  };

  return isReactQueryRoute ? reactQueryData ?? fallback : selectedData;
};

export default useCountryRegionLinksShim;
